module.exports = __webpack_public_path__ + "static/logo-color-32f73e756d06f810705228313ac8c0b4.svg";